import React, { useState } from "react";
import { ReactComponent as Hopital } from "../../../assets/illustrations/illustration-hospital.svg";
import { ReactComponent as Close } from "../../../assets/icons/icon-close.svg";

import "./styles.scss";

import Button from "../../../components/ButtonUI";
import ConfirmModal from "./ConfirmModalDelete";
import { deleteClient } from "../../../api/client";
import makeToast from "../../../components/Snackbar";
import { FaPencilAlt } from "react-icons/fa";

const colorAvatar = [
  "#ccd2ff",
  "#d5f0f7",
  "#ffecba",
  "#fff7ab",
  "#ffccd2",
  "#ffe2c8",
];

type Props = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> & {
  clientDetails: any;
  openModal: boolean;
  setOpenModal: Function;
  setSelectedClient: Function;
  selectedClient: string;
  setRefreshClient: Function;
  setClientData: Function;
  setModalAdd: Function;
  setColorIndex: Function;
  i: number;
};

const CardClient: React.FC<Props> = ({
  clientDetails,
  openModal,
  setOpenModal,
  setSelectedClient,
  selectedClient,
  setColorIndex,
  setRefreshClient,
  setClientData,
  setModalAdd,
  i,
}) => {
  const [deleteConfirmModal, setDeleteConfirmModal] = useState(false);

  const handleDelete = async (id: string) => {
    try {
      await deleteClient(id);
      makeToast("success", "suppression du Client effectuée avec succès.");
      setRefreshClient(prev => !prev);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div
        className={`card-patient justify-between relative bg-white ${
          selectedClient === clientDetails?._id
        }`}
      >
        <div className="cursor-pointer flex flex-col items-start">
          <div className="flex patient-info ">
            <div
              className="rounded-full h-14 w-14 flexCenter mx-5 my-auto"
              style={{
                backgroundColor: colorAvatar[i % colorAvatar.length],
                cursor: "pointer",
              }}
            >
              <Hopital />
            </div>
            <div className="details" style={{ cursor: "pointer" }}>
              <div className="flex-grow ">
                <p
                  className="card-title capitalize"
                  style={{ cursor: "pointer" }}
                >
                  {clientDetails.name}
                </p>
              </div>
             
            </div>
          </div>
         
        </div>
        <div className="absolute right-2 top-1">
          <Button
            status="icon-secondary"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              setDeleteConfirmModal(true);
            }}
            style={{ height: "40px", width: "40px", padding: 0 }}
          >
            <Close />
          </Button>
        </div>
        <div className="absolute right-2 top-16 " style={{cursor: "pointer"}}>
          <Button
            status="icon-secondary"
            onClick={(e) => {
              e.stopPropagation();
              setSelectedClient(clientDetails?._id);
              setClientData(clientDetails);
              setModalAdd(true);
              //setEditModeSharedclient(true); 
            }}
            style={{ height: "40px", width: "40px", padding: 0 }}
          >
          <FaPencilAlt />
          </Button>
        </div>
      </div>
      {deleteConfirmModal && (
        <ConfirmModal
          action={() => {
            handleDelete(clientDetails?._id);
          }}
          setOpenModal={setDeleteConfirmModal}
        />
      )}
      
    </>
  );
};

export default CardClient;
